import { render, staticRenderFns } from "./VhfCallRecordPanel.vue?vue&type=template&id=5060258c&scoped=true"
import script from "./VhfCallRecordPanel.vue?vue&type=script&lang=js"
export * from "./VhfCallRecordPanel.vue?vue&type=script&lang=js"
import style0 from "./VhfCallRecordPanel.vue?vue&type=style&index=0&id=5060258c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5060258c",
  null
  
)

export default component.exports